import { LogEntry } from '../../LogStoreContext/Context';

// Maximum request body size in bytes (700KB) since CloudWatch Logs has a limit of 1MB per PutLogEvents request
const MAX_REQUEST_SIZE = 700 * 1024;

function calculateRequestSize(logs: LogEntry[]): number {
  const payload = { logs };
  return new Blob([JSON.stringify(payload)]).size;
}

function splitArrayBySize(array: LogEntry[]): LogEntry[][] {
  // If array is empty, return empty result
  if (array.length === 0) {
    return [[]];
  }

  // If array has only one element or size is within limit, return as single chunk
  if (array.length === 1 || calculateRequestSize(array) <= MAX_REQUEST_SIZE) {
    return [array];
  }

  // Split array in half and recursively process each half
  const midpoint = Math.floor(array.length / 2);
  const leftHalf = array.slice(0, midpoint);
  const rightHalf = array.slice(midpoint);

  return [...splitArrayBySize(leftHalf), ...splitArrayBySize(rightHalf)];
}

function makeFetchRequest({ fetch_, config, logs }) {
  return fetch_(`${config.AGENT_SERVICE_V2_URL}/user/put-log-events`, {
    method: 'POST',
    body: JSON.stringify({ logs }),
  });
}

export default async function logCloudWatchEvents({ fetch_, config, logs }) {
  const chunks = splitArrayBySize(logs);

  const requests = chunks.map((chunk) => makeFetchRequest({ fetch_, config, logs: chunk }));

  await Promise.all(requests);
}
